var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedemptionIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8299 1.68098L5.17787 5.52494C4.28795 5.92046 3.70703 6.81038 3.70703 7.78682V13.596C3.70703 20.4558 8.45327 26.8707 14.831 28.428C21.2088 26.8707 25.955 20.4558 25.955 13.596V7.78682C25.955 6.81038 25.3741 5.92046 24.4842 5.52494L15.8322 1.68098C15.2018 1.3967 14.4602 1.3967 13.8299 1.68098V1.68098ZM14.831 14.8197H23.483C22.828 19.912 19.429 24.4481 14.831 25.8695V14.832H6.17903V7.78682L14.831 3.94286V14.8197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionIconLight);
export default __webpack_public_path__ + "static/media/RedemptionIconLight.a15eabe98a9019e7c3671eabc5549b4b.svg";
export { ForwardRef as ReactComponent };